var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnCerrar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7991",
    "data-name": "Grupo 7991",
    transform: "translate(-0.199 0.063)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_520",
    "data-name": "Elipse 520",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0.199 -0.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7141",
    "data-name": "Grupo 7141",
    transform: "translate(10.372 9.914)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1029",
    "data-name": "L\\xEDnea 1029",
    x2: 10.126,
    y2: 10.126,
    fill: "none",
    stroke: "#003763",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1030",
    "data-name": "L\\xEDnea 1030",
    x1: 10.126,
    y2: 10.126,
    fill: "none",
    stroke: "#003763",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCerrar);
export default __webpack_public_path__ + "static/media/btn-cerrar.872b6f2ffbf9d990d5831b99209d6a2e.svg";
export { ForwardRef as ReactComponent };